<footer *ngIf="!hideFooter">
    <div class="footer-info">
        <section class="links">
            <div>
                <h3>Platform</h3>
                <a
                    [routerLink]="['/system/accessibility-statement']"
                    aria-label="Accessbility Statement link"
                    target="_blank"
                    rel="noopener noreferrer"
                    >{{ copy.ACCESSIBILITY }}</a
                >
                <a
                    aria-label="Clickable Privacy Notice link"
                    href="https://secured.team/privacy-policy/"
                    target="_blank"
                    >{{ copy.PRIVACY }}</a
                >
                <!-- <a aria-label="Clickable Roadmap link" href="https://securedteam.notion.site/361b86788dc2493e95c990d77594e6ed?v=7bfe3912023b41f28739e4976d6f9861" target="_blank" rel="noopener noreferrer">{{ copy.ROADMAP }}</a> -->
                <a
                    [routerLink]="['/system/termsofservice']"
                    aria-label="Clickable Terms of Service link"
                    target="_blank"
                    rel="noopener noreferrer"
                    >{{ copy.TERMS }}</a
                >
                <a
                    aria-label="Clickable Usage Statistics link"
                    [routerLink]="['/system/usage']"
                    target="_blank"
                    rel="noopener noreferrer"
                    >{{ copy.USAGE }}</a
                >
            </div>
            <div>
                <h3>Help</h3>
                <a
                    [routerLink]="['/about-us']"
                    aria-label="About Us Page link"
                    rel="noopener noreferrer">
                    About Us
                </a>
                <a
                    aria-label="Clickable Ask for Help link"
                    href="mailto:info@secured.team?subject=CLARK Help"
                    >{{ copy.HELP }}</a
                >
                <a
                    [routerLink]="['/editorial-process']"
                    aria-label="Editorial Process"
                    rel="noopener noreferrer"
                    >Editorial Process</a
                >
                <a
                    [routerLink]="['/contribute-page']"
                    aria-label="Contribute Page"
                    rel="noopener noreferrer">
                    Resources for Contributors
                </a>
                <a
                    aria-label="Clickable Troubleshooting link"
                    href="http://help.clark.center"
                    target="_blank"
                    rel="noopener noreferrer"
                    >Troubleshooting</a
                >
                <!-- <a aria-label="Clickable Tutorial link" href="http://about.clark.center/tutorial" target="_blank" rel="noopener noreferrer">{{ copy.TUTORIAL }}</a> -->
            </div>
            <div>
                <h3>General Information</h3>
                <a
                    aria-label="Clickable About Us link"
                    href="http://clark.center/about"
                    >{{ copy.ABOUT }}</a
                >
                <a
                    aria-label="Clickable Blog link"
                    href="https://blogs.clark.center/"
                    target="_blank"
                    >{{ copy.BLOG }}</a
                >
                <a
                    aria-label="Clickable Meet the Team link"
                    href="http://secured.team/team"
                    target="_blank"
                    rel="noopener noreferrer"
                    >{{ copy.TEAM }}</a
                >
                <a
                    [routerLink]="['/press']"
                    aria-label="Press and Media link"
                    >{{ copy.PRESS }}</a
                >
                <a
                    aria-label="Newsletter Subscription modal"
                    (activate)="toggleNewsletterBanner()"
                    >{{ copy.SUBSCRIBE }}</a
                >
            </div>
        </section>
        <section class="grants">
            <div class="images">
                <div class="logo-wrapper">
                    <a href="https://www.towson.edu/" target="_blank">
                        <img
                            src="assets/images/towson_logo.png"
                            alt="Towson University Logo" />
                    </a>
                </div>
            </div>
        </section>
    </div>
    <div class="grants">
        <div class="images bottom">
            <div class="logo-wrapper">
                <a href="https://www.ncyte.net/" target="_blank">
                    <img
                        class="ncyte"
                        alt="NCyTE Center Logo"
                        src="assets/images/collections/white_ncyte_logo.png" />
                </a>
            </div>
            <div class="logo-wrapper">
                <a
                    href="https://www.csusb.edu/"
                    target="_blank"
                    aria-label="CSUSB home page">
                    <img
                        src="assets/images/CSUSB.png"
                        class="csusb"
                        alt="CSUSB Logo" />
                </a>
            </div>
            <div class="logo-wrapper">
                <a
                    href="https://www.gula.tech/"
                    target="_blank"
                    aria-label="GULA Tech">
                    <img
                        src="assets/images/gula_logo.png"
                        class="gula"
                        alt="GULA Tech" />
                </a>
            </div>
        </div>
    </div>
    <div class="share-icons">
        <a
            href="https://www.instagram.com/clark_secured/"
            class="button icon-only instagram"
            id="instagram"
            aria-label="Go to CLARK Instagram page">
            <i class="fab fa-instagram"></i>
        </a>
        <a
            href="https://twitter.com/theclarkcyber"
            class="button icon-only twitter"
            id="twitter"
            aria-label="Go to CLARK Twitter page">
            <i class="fab fa-twitter"></i>
        </a>
        <a
            href="https://linkedin.com/company/theclarkcyber"
            class="button icon-only linkedin"
            id="linkedin"
            aria-label="Go to CLARK LinkedIn page">
            <i class="fab fa-linkedin"></i>
        </a>
    </div>
    <p>{{ copy.SUPPORTEDBY }}</p>
</footer>
